import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["font-weight-bold", {
            'text-green': _ctx.status === 'Active',
            'text-warning': _ctx.status === 'Cancelled'
        }])
  }, _toDisplayString(_ctx.status), 3))
}